/**
 * @ngdoc overview
 * @name evtviewer.interface
 * @description 
 * # evtviewer.interface
 * This is the interface module. 
 * It includes all of our components for the upper level user interface of EVT application.
 * The interface module is loaded by default when EVT application is started. 
 * 
 * The list below shows a high level breakdown of each of the services/factories, filters, 
 * directives and testing components available within this module.
 *
 * - {@link evtviewer.interface.evtInterface evtInterface} service
 * - {@link evtviewer.interface.controller:InterfaceCtrl InterfaceCtrl} controller
**/
angular.module('evtviewer.interface', []);